import { Routes } from '@angular/router';
import { Login } from './components/login/login';
import { Agree } from './components/agree/agree';
import { AuditRequest } from './components/audit-request/audit-request';
import { IndirectPurchaserStates } from './components/indirect-purchaser-states/indirect-purchaser-states';
import { File } from './components/file/file';
import { Results } from './components/results/results';
import { Complete } from './components/complete/complete';
import { Home } from './components/home/home';
import { CourtDocuments } from './components/court-documents/court-documents';
import { Notice } from './components/notice/notice';
import { ContactInformation } from './components/contact-information/contact-information';

export const routes: Routes = [

  { path: '', component: Home },
  { path: 'home', component: Home },
  { path: 'court-documents', component: CourtDocuments },
  { path: 'notice', component: Notice },
  { path: 'contact-information', component: ContactInformation },

  { path: 'login', component: Login },
  { path: 'agree', component: Agree },
  { path: 'file', component: File },
  { path: 'audit-request', component: AuditRequest },
  { path: 'complete', component: Complete },
  { path: 'indirect-purchaser-states', component: IndirectPurchaserStates },
  { path: 'results', component: Results },
  { path: '**', redirectTo: '' }

  //{ path: '', pathMatch: 'full', redirectTo: 'tpp-instructions' },
  //{ path: 'tpp-instructions', component: TppInstructions },
  //{ path: 'tpp-claimants', component: TppClaimants },
  //{ path: 'tpp-complete', component: TppComplete },
  //{ path: 'home', component: Home },
  //{ path: '**', redirectTo: 'tpp-instructions' },

];
